import { createGlobalStyle } from 'styled-components'

const WhileDraggingStyle = createGlobalStyle`
  html, body {
    /* We need this because '@dnd-kit/core' uses the element.scrollBy API which
       uses the browser's scrolling preference by default, which is set by the user.
       Most users pick smooth scrolling, and for this it's a problem because when
       the method is called rapidly it cancels the previous smooth scroll attempts
       producing a jerky & slow experience */
    scroll-behavior: auto !important;
  }

  * {
    cursor: grabbing !important;
  }
`

export default WhileDraggingStyle
